<template>
    <modal :adaptive="true" height="auto" name="finetune" style="z-index: 1071">
        <d-row>
            <d-col lg="12">
                <d-card class="card card-post">
                    <d-card-body>
                        <b-collapse :visible="!optionsPanelVisible">
                            <h5 class="text-center" v-if="desiredPlan">
                                Select an available plan or <b-button @click="optionsPanelVisible = !optionsPanelVisible" class="btn-outline-accent">FINETUNE ACCOUNT</b-button>
                            </h5>
                            <h5 class="text-center" v-else>Select an available plan or finetune your Ivanhoe.io account.</h5>
                            <v-client-table v-if="billings" class="dataTables_wrapper" :data="billings" :columns="plansTable.columns" :options="plansTable.options" ref="table">
                                <d-button-group slot="buttons" slot-scope="props" class="d-flex justify-content-center">
                                    <d-button
                                        class="btn-success btn-sm"
                                        :disabled="props.row.id === userInfo.subscription.plan.id"
                                        v-if="props.row.suitable_for_current_options"
                                        :class="{ 'current-btn': props.row.id === userInfo.subscription.plan.id}"
                                        @click="checkPlan(props.row.id)">
                                        <span v-if="props.row.id === userInfo.subscription.plan.id">Current plan</span>
                                        <span v-else>Switch to plan</span>
                                    </d-button>
                                    <d-button v-else class="btn-warning btn-sm" @click="optionsPanel(props.row.id)">
                                        <span>Finetune account</span>
                                    </d-button>
                                </d-button-group>
                            </v-client-table>
                        </b-collapse>
                        <br>
                        <b-collapse :visible="optionsPanelVisible">
                                <h5 class="text-center">
                                    Finetune account or <b-button @click="optionsPanelVisible = !optionsPanelVisible" class="btn-outline-accent">SELECT AN AVAILABLE PLAN</b-button>
                                </h5>
                                <b-tabs active-nav-item-class="font-weight-bold" card>
                                    <b-tab :title-link-class="'text-dark'" active>
                                        <template v-slot:title>
                                            WEBSITES <b-badge v-if="planErrors.websites" variant="danger">{{planErrors.websites}} too many</b-badge>
                                        </template>
                                        <v-client-table class="dataTables_wrapper" :data="websites" :columns="websitesTable.columns" :options="websitesTable.options">
                                            <d-col slot="buttons" class="buttons" slot-scope="props" size="small">
                                                <d-button v-if="props.row.deprecated_at" @click="toggleDeprecatedStatus('website', props.row.id)" class="btn-success btn-sm">
                                                    <span>Undo removal</span>
                                                </d-button>
                                                <d-button v-else @click="toggleDeprecatedStatus('website', props.row.id)" class="btn-warning btn-sm">
                                                    <span>Remove domain</span>
                                                </d-button>
                                            </d-col>
                                        </v-client-table>
                                    </b-tab>
                                    <b-tab :title-link-class="'text-dark'">
                                        <template v-slot:title>
                                            NETWORKS <b-badge v-if="planErrors.networks" variant="danger">{{planErrors.networks}} too many</b-badge>
                                        </template>
                                        <v-client-table class="dataTables_wrapper" :data="medias" :columns="mediasTable.columns" :options="mediasTable.options">
                                            <d-col slot="buttons" class="buttons" slot-scope="props" size="small">
                                                <d-button v-if="props.row.deprecated_at" @click="toggleDeprecatedStatus('media', props.row.website.id, props.row.account.id)" class="btn-success btn-sm">
                                                    <span>Undo removal</span>
                                                </d-button>
                                                <d-button v-else @click="toggleDeprecatedStatus('media', props.row.website.id, props.row.account.id)" class="btn-warning btn-sm">
                                                    <span>Remove media</span>
                                                </d-button>
                                            </d-col>
                                        </v-client-table>
                                    </b-tab>
                                    <b-tab :title-link-class="'text-dark'">
                                        <template v-slot:title>
                                            GA <b-badge v-if="planErrors.gaIntegrations" variant="danger">{{planErrors.gaIntegrations}} too many</b-badge>
                                        </template>
                                        <v-client-table class="dataTables_wrapper" :data="GAIntegrations" :columns="websitesTable.columns" :options="websitesTable.options">
                                            <d-col slot="buttons" class="buttons" slot-scope="props" size="small">
                                                <d-button v-if="props.row.googleAnalyticsIntegration.deprecated_at" @click="toggleDeprecatedStatus('googleAnalytics', props.row.id)" class="btn-success btn-sm">
                                                    <span>Undo removal</span>
                                                </d-button>
                                                <d-button v-else @click="toggleDeprecatedStatus('googleAnalytics', props.row.id)" class="btn-warning btn-sm">
                                                    <span>Remove integration</span>
                                                </d-button>
                                            </d-col>
                                        </v-client-table>
                                    </b-tab>
                                    <b-tab :title-link-class="'text-dark'">
                                        <template v-slot:title>
                                            BA <b-badge v-if="planErrors.baIntegrations" variant="danger">{{planErrors.baIntegrations}} too many</b-badge>
                                        </template>
                                        <v-client-table class="dataTables_wrapper" :data="BAIntegrations" :columns="websitesTable.columns" :options="websitesTable.options">
                                            <d-col slot="buttons" class="buttons" slot-scope="props" size="small">
                                                <d-button v-if="props.row.bingAdsIntegration.deprecated_at" @click="toggleDeprecatedStatus('bingAds', props.row.id)" class="btn-success btn-sm">
                                                    <span>Undo removal</span>
                                                </d-button>
                                                <d-button v-else @click="toggleDeprecatedStatus('bingAds', props.row.id)" class="btn-warning btn-sm">
                                                    <span>Remove integration</span>
                                                </d-button>
                                            </d-col>
                                        </v-client-table>
                                    </b-tab>
                                </b-tabs>
                        </b-collapse>
                    </d-card-body>
                </d-card>
            </d-col>
        </d-row>
    </modal>
</template>

<script>
import { WebsiteService } from '@/main';
import { BillingService } from '@/main';
import notification from '@/mixins/notification';

export default {
    mixins: [notification],

    data() {
        return {
            planErrors: {},
            desiredPlan: null,
            billings: null,
            plansTable: {
                columns: ['external_name', 'price', 'buttons'],
                options: {
                    perPage: 25,
                    pagination: { show: false },
                    texts: { count: '' },
                    skin: 'transaction-history table dataTable',
                    headings: {
                        external_name: 'Plan',
                        price: 'Price',
                        buttons: 'Action',
                    },
                }
            },
            websitesTable: {
                columns: ['domain', 'buttons'],
                options: {
                    perPage: 5,
                    pagination: { nav: 'scroll' },
                    texts: { count: "Showing {from} to {to} of {count} ||" },
                    skin: 'transaction-history table dataTable',
                    headings: {
                        domain: 'Domain',
                        buttons: 'Action',
                    },
                    templates: {
                        'domain': function (h, row) {
                            return <span class='p-1'>{row.domain}</span>
                        }
                    }
                }
            },
            mediasTable: {
                columns: ['website.domain', 'account.affiliateNetwork.human_readable_name', 'buttons'],
                options: {
                    perPage: 5,
                    pagination: { nav: 'scroll' },
                    texts: { count: "Showing {from} to {to} of {count} ||" },
                    skin: 'transaction-history table dataTable',
                    headings: {
                        'website.domain': 'Domain',
                        'account.affiliateNetwork.human_readable_name': 'Network',
                        buttons: 'Action',
                    },
                    templates: {
                        'website.domain': function (h, row) {
                            return <span class='p-1'>{row.website.domain}</span>
                        }
                    }
                }
            },
            optionsPanelVisible: false
        };
    },
    methods: {
        async checkPlanOptions(planId) {
            try{
                await BillingService.checkPlan(planId)
                this.planErrors = {}
            } catch (e) {
                this.planErrors = e.response.data
            }
        },

        async optionsPanel(planId) {
            await this.checkPlanOptions(planId)
            this.desiredPlan = planId;
            this.optionsPanelVisible = true;
        },

        async getBilling() {
            this.billings = await BillingService.get();
        },

        async getPlanApplyings(id) {
            try {
                const plans = await BillingService.getPlanApplyings(id)
                this.$store.commit('setPlanApplyingOptions', plans)
            } catch(e) {
                this.showNotification('warn', 'We have a problem', 'Plan not availbe')
                console.log(e)
            }
        },

        async checkPlan(id) {
            try {
                await BillingService.checkPlan(id)
                this.getPlanApplyings(id)
                this.$store.commit('setPlanId', id)
                this.$modal.hide('finetune');
            } catch(e) {
                this.showNotification('error-notification', 'Oops! we have a problem', e.response.data.message)
            }
        },

        async toggleDeprecatedStatus(type, websiteId, accountId = null) {
            try {
                switch (type) {
                    case 'website':
                        await WebsiteService.toggleDeprecatedStatus(websiteId)
                        break;
                    case 'media':
                        await WebsiteService.toggleMediaDeprecatedStatus(websiteId, accountId)
                        break;
                    case 'bingAds':
                        await WebsiteService.toggleBingAdsDeprecatedStatus(websiteId)
                        break;
                    case 'googleAnalytics':
                        await WebsiteService.toggleGoogleAnalyticsDeprecatedStatus(websiteId)
                        break;
                }
                await this.getBilling()
                await this.checkPlanOptions(this.desiredPlan)
                await this.$store.dispatch('getUserInfo')
            } catch (e) {
                this.showNotification('warn', 'Alert', 'Something went wrong')
            }
        },
    },

    created() {
        this.getBilling()
    },

    computed: {
        userInfo () {
            return this.$store.getters.userInfo
        },

        isActive () {
            return this.$store.getters.getBillingInfo.planId
        },

        websites () {
            return this.$store.getters.userInfo.websites
        },

        BAIntegrations () {
            return this.$store.getters.userInfo.websites.filter(website => website.bingAdsIntegration != null)
        },

        GAIntegrations () {
            return this.$store.getters.userInfo.websites.filter(website => website.googleAnalyticsIntegration != null)
        },

        medias () {
            return this.$store.getters.userInfo.medias
        }
    }
};
</script>
